import { createBasicSelector } from 'util/redux'
import { selectCurrentUser } from './selectCurrentUser'

export const selectCurrentUser2faEnabled = createBasicSelector(
  selectCurrentUser,
  user => user.status2fa !== 'disabled'
)
